<input
  matInput

  [matDatepicker]="picker"

  [formControl]="control"

  class="kt-input kt-input-sm"
/>

<mat-datepicker-toggle
  matSuffix
  [for]="picker">
</mat-datepicker-toggle>

<mat-datepicker
  #picker>
</mat-datepicker>